export default {"src":"/_next/static/media/moresports.67587c66.svg","height":1757,"width":1411,"blurWidth":0,"blurHeight":0};